import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import DarkModeContext from "../../contexes/DarkModeContext";
import { StageContext } from "../../contexes/OrderIdContext";
import PageHeader from "../PageHeader";
import { UATLandingPage } from "./UATLandingPage";
import UATProjectView from "./UATProjectView";
import { Stage } from "../../lusca-search-api/generated-src";
import { DEFAULT_STAGE } from "../../constants";
import useDocumentTitle from "../../hooks/useDocumentTitle";

export const UatPortal: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [darkMode, setDarkMode] = useState(false);
  const stageParam = (searchParams.get("stage") || DEFAULT_STAGE) as Stage;
  useDocumentTitle("UAT Dashboard");

  const getProjectId = (): string | null => {
    return searchParams.get("project");
  };

  const projectId = getProjectId();

  return (
    <DarkModeContext.Provider value={darkMode}>
      <StageContext.Provider value={stageParam}>
        <PageHeader setDarkMode={setDarkMode} />
        <AppLayout
          contentType="default"
          headerSelector="#h"
          maxContentWidth={1700}
          navigationHide
          toolsHide
          content={
            projectId ? (
              <UATProjectView projectId={projectId} />
            ) : (
              <UATLandingPage />
            )
          }
        />
      </StageContext.Provider>
    </DarkModeContext.Provider>
  );
};
